module.exports = __webpack_public_path__ + "assets/ico-input-valid.dc978f9d.svg";